import React from 'react';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

const CampaignHeader = ({
  title,
  loading,
  onBack,
  onSave,
  onActivate,
  showActivateButton,
  status,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{ mr: 2 }}
      >
        Back
      </Button>
      <Typography variant="h4" gutterBottom sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      {!loading && (
        <Box sx={{ display: 'flex', gap: 2 }}>
          {showActivateButton && status === 'draft' && (
            <Button
              variant="contained"
              color="success"
              onClick={onActivate}
            >
              Activate Campaign
            </Button>
          )}
          <Button
            variant="contained"
            onClick={onSave}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Save Changes'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default CampaignHeader; 